import ControlType from './ControlType';
import FormControl from './FormControl';

export default class SelectInput extends FormControl<HTMLSelectElement> {
  type = ControlType.Select;

  setOptions(options: [string, string, boolean?][], promptText?: string) {
    const $input = this.$inputs[0];

    $input.options.length = 0;

    if (promptText) {
      $input.options.add(new Option(promptText, ''));
    }

    options.forEach(([text, value, isSelected]) => $input.options.add(new Option(text, value, false, isSelected)));
  }
}
